import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTheme} from '@mui/material/styles';

function greetingForHour(hour) {
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
}

// Dashboard heading shown in the header bar on the home route. The
// `data-testid` is also what Header's `hideWhenEmpty` looks for, so the bar
// stays visible on the dashboard even without a breadcrumb trail. An optional
// `logo` node renders to the left of the greeting (e.g. the site/department
// logo).
export default function DashboardGreeting({displayName, siteName, logo}) {
    const theme = useTheme();
    // The full date plus a department name is wider than a phone header once the
    // search field has taken its end of the row, and wrapping it wastes two lines
    // on something nobody reads twice. The year is today's year — drop it, and
    // abbreviate the rest. Phones only: by sm there is room for the long form.
    const compact = useMediaQuery(theme.breakpoints.down('sm'));

    const now = new Date();
    const greeting = greetingForHour(now.getHours());
    const dateLabel = now.toLocaleDateString(undefined, compact
        ? {weekday: 'short', month: 'short', day: 'numeric'}
        : {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'});

    return (
        <Box data-testid="dashboard-greeting" sx={{display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0}}>
            {logo}
            {/* Both minWidth:0 guards are load-bearing: a flex item defaults to
                min-content, so without them the date line ("Tuesday, August 25,
                2026 · Test Fire Department") sets the header's width and runs to
                the very edge of a phone screen instead of wrapping inside it. */}
            <Box sx={{minWidth: 0}}>
                <Typography variant="h5" sx={{fontWeight: 700, lineHeight: 1.2}}>
                    {displayName ? `${greeting}, ${displayName}` : greeting}
                </Typography>
                <Typography variant="body2" sx={{color: 'text.secondary', mt: 0.25}}>
                    {[dateLabel, siteName].filter(Boolean).join(' · ')}
                </Typography>
            </Box>
        </Box>
    );
}
